import { IMAGE_LOADER, ImageLoaderConfig } from '@angular/common';

export interface SizedImage {
  width: number;
  src: string;
}

export interface AppImageLoaderConfig {
  placeholders: Record<string, string>;
  sizedImages: Record<string, SizedImage[]>;
}

export function provideAppImageLoader({
  placeholders,
  sizedImages,
}: AppImageLoaderConfig) {
  return {
    provide: IMAGE_LOADER,
    useValue: (config: ImageLoaderConfig) => {
      if (config.isPlaceholder) {
        if (placeholders[config.src]) {
          return placeholders[config.src];
        }
        console.warn(`No placeholder configured for ${config.src}`);
      }
      const desiredWith = config.width;
      if (desiredWith) {
        const optimisedSrc = sizedImages[config.src]?.find(
          ({ width }) => width >= desiredWith,
        )?.src;
        if (optimisedSrc) {
          return optimisedSrc;
        } else if (sizedImages[config.src]) {
          console.debug(
            `No optimised sources configured for ${config.src} at ${desiredWith}`,
          );
        } else if (!config.src.endsWith('.svg')) {
          console.warn(`No optimised sources configured for ${config.src}`);
        }
      }
      return config.src;
    },
  };
}
